module.exports = __webpack_public_path__ + "static/media/tile-roof.41a9b510.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/tile-roof.png
// module id = 874
// module chunks = 1